import { isClientSide, isLocalHost } from 'utility/constant';
import { allowAppInsight, getLoggingLevelTelemetry } from './utils';

declare global {
  interface Window {
    Microsoft: any;
    appInsights: any;
  }
}

const connectionString = `${process.env.NEXT_PUBLIC_APP_INSIGHT_CONNECTION}`;

let appInsight: any | null = null;

if (
  isClientSide &&
  connectionString &&
  allowAppInsight() &&
  !window.appInsights &&
  typeof window.Microsoft !== 'undefined' &&
  window.Microsoft.ApplicationInsights
) {
  const appInsightConfig = {
    connectionString,
    disableTelemetry: isLocalHost,
    loggingLevelTelemetry: getLoggingLevelTelemetry(),
    enableAutoRouteTracking: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    isBrowserLinkTrackingEnabled: true,
  };

  window.appInsights = new window.Microsoft.ApplicationInsights.ApplicationInsights({
    config: appInsightConfig,
  });

  window.appInsights.loadAppInsights();

  window.appInsights.addTelemetryInitializer((envelope) => {
    if (!envelope.tags) {
      envelope.tags = [];
    }
    envelope.tags.push({ 'ai.cloud.role': 'FrontEnd' });
  });

  // window.appInsights.trackPageView({ properties: collectProperties() });

  appInsight = window.appInsights;
}

export { appInsight };
